import { render, staticRenderFns } from "./MovieOrderForm.vue?vue&type=template&id=9a331e70&scoped=true"
import script from "./MovieOrderForm.vue?vue&type=script&lang=js"
export * from "./MovieOrderForm.vue?vue&type=script&lang=js"
import style0 from "./MovieOrderForm.vue?vue&type=style&index=0&id=9a331e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a331e70",
  null
  
)

export default component.exports